import {Component, OnInit} from '@angular/core';
import {OpencvService} from '../../../../services/opencv/opencv.service';

@Component({
  selector: 'app-opencv-menu',
  templateUrl: './opencv-menu.component.html',
  styleUrls: ['./opencv-menu.component.scss']
})
export class OpencvMenuComponent implements OnInit {

  constructor(public opencvService: OpencvService) {
  }

  ngOnInit() {
  }

  changeOptionSelect() {
    const e = document.getElementById('services') as HTMLSelectElement;
    const selected = e.options[e.selectedIndex].value;

    this.opencvService.currentClassifier = selected;
    this.opencvService.stopVideoDetection();
    setTimeout(() => {
      this.opencvService.videoDetection();
    }, 1000);
  }

}
